import Axios from "axios"
import {
    FREELANCER_LIST_HOME_REQUEST,
    FREELANCER_LIST_HOME_SUCCESS,
    FREELANCER_LIST_HOME_FAIL
} from "../constants/freelancerConstants"

export const FreelancerListHomeData = () => async (dispatch) => {
    dispatch({
        type: FREELANCER_LIST_HOME_REQUEST
    });
    try {
        const { data } = await Axios.get(`${process.env.REACT_APP_API_URI}/api/v1/homepage-users`);
        dispatch({ type: FREELANCER_LIST_HOME_SUCCESS, payload: data});
    } catch (error) {
        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message;
        dispatch({ type: FREELANCER_LIST_HOME_FAIL, payload: message });
    }
};